import { withTranslation } from "react-i18next";
import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Helmet } from 'react-helmet-async';
import Main from './Main';
import New from './New';
import View from './View';
import PropertyStatus from './PropertyStatus';

class Business extends Component {
  render() {
    const { t } = this.props;
    return <>
        <Helmet>
          <title>{t("My Businesses")}</title>
        </Helmet>
        <Switch>
          <Route exact path='/business' component={Main} />
          <Route exact path='/business/new' component={New} />
          <Route path='/business/:businessId/status/:propertyId' component={PropertyStatus} />
          <Route path='/business/:businessId' component={View} />
        </Switch>
      </>;
  }

}

export default withTranslation()(Business);